
import {
    CHANGE_COLUMNS,
    CHANGE_COMP,
    CHANGE_CONTENT_FONT,
    CHANGE_HEADER_FONT, TOGGLE_INCLUDE_UNRECOGNIZED_CHIPS,
    CHANGE_LOCATIONS,
    IAction
} from "../store";
import {getInitialDisplayState} from "../store/get-initial-display-state";
import {ColumnKey} from "../constants/display-columns";


export interface DisplayState {
    Comp: number | null
    SelectedColumns: ColumnKey[];
    ContentFontSize: number;
    HeaderFontSize: number;
    SelectedLocations: string[];
    IncludeUnrecognizedChips: boolean;
}

export function displayReducer(state: DisplayState | undefined, action: IAction) {
    if(state === undefined) {  // Redux will inject from a preloadedState
        return getInitialDisplayState()
    }

    switch (action.type) {
        case CHANGE_COLUMNS:
            const columnKey = action.payload.columnKey
            if(state.SelectedColumns.includes(columnKey)) {
                return {
                    ...state,
                    SelectedColumns: state.SelectedColumns.filter(selectedColumns => selectedColumns !== columnKey)
                }
            }
            return {
                ...state,
                SelectedColumns: state.SelectedColumns.concat(columnKey)
            }
        case CHANGE_CONTENT_FONT:
            return {
                ...state,
                ContentFontSize: action.payload.fontSize
            }
        case CHANGE_HEADER_FONT:
            return {
                ...state,
                HeaderFontSize: action.payload.fontSize
            }
        case CHANGE_LOCATIONS:
            const location = action.payload.location
            if(state.SelectedLocations.includes(location)) {
                return {
                    ...state,
                    SelectedLocations: state.SelectedLocations.filter(selectedLocation => selectedLocation !== location)
                }
            }
            return {
                ...state,
                SelectedLocations: state.SelectedLocations.concat(location)
            }
        case CHANGE_COMP:
            return {
                ...state,
                Comp: action.payload.comp
            }
        case TOGGLE_INCLUDE_UNRECOGNIZED_CHIPS:
            return {
                ...state,
                IncludeUnrecognizedChips: !state.IncludeUnrecognizedChips
            }
        default:
            return state
    }
}